<template>
  <div style="margin-top: 63px">
    <div class="hero">
      <div class="hero-ctn">
        <h1>{{ $t('alumniTitle') }}</h1>
        <p>
          {{ $t('alumniDescriotion') }}
        </p>
      </div>
    </div>
    <div style="background-color: #f5f6fa">
      <div class="container">
        <div class="card" style="padding-bottom: 60px">
          <div class="items" v-for="(item, idx) in stories" :key="idx"
            @click="goToStoryDetail(item.id, item.title)">
            <div style="height: 240px">
              <img :src="item.image_url" alt="" style="width: 100%; height: 100%; border-radius: 20px 20px 0 0" />
            </div>
            <div class="content">
              <div style="height: 70px">
                <h2>{{ item.title }}</h2>
              </div>
              <p class="description-class">{{ item.caption }}</p>
            </div>
          </div>
        </div>
        <EmptyData v-if="!stories || !stories.length" message="Belum ada Cerita Alumni saat ini" />
        <v-row justify="center mt-10" v-if="total > 1">
          <v-col>
            <Pagination @pageChanged="onPageChanged" :currentPage="currentPage" :totalPages="total" />
          </v-col>
        </v-row>
      </div>
    </div>
    <v-card elevation="0" class="call-center-container">
      <v-row style="padding: 40px">
        <v-col cols="7">
          <div class="call-center-title" style="font-size: 24px;">
            {{ $t('alumniHelpTitle') }}
          </div>
          <div class="call-center-desc">
            {{ $t('alumniHelpDescription') }}
          </div>
        </v-col>
        <v-col cols="1" />
        <v-col cols="4" class="call-center-button" @click="sendWa">
          <v-btn class="btn" elevation="0"> {{ $t('alumniAct') }} </v-btn>
        </v-col>
      </v-row>
    </v-card>
  </div>
</template>

<script>
import EmptyData from "../../others/EmptyData.vue";
import Pagination from '@/components/others/Pagination.vue'

export default {
  name: "DesktopAlumniStories",
  components: {
    EmptyData,
    Pagination
  },
  data() {
    return {
      stories: [],
      currentPage: 1,
      total: 1,
    };
  },
  watch: {
    "$i18n.locale"() {
      this.getStories();
    },
  },
  methods: {
    sendWa() {
      this.$gtag.event('click', {
        event_category: 'Button',
        event_label: 'Contact WhatsApp - Alumni Stories',
        value: 1,
      });
      window.open("https://wa.me/6281234567890", "_blank");
    },
    page(act) {
      if (act === "prev") {
        if (this.currentPage <= 1) return;
        this.currentPage--;
      } else {
        if (this.currentPage >= this.total) return;
        this.currentPage++;
      }
      this.$gtag.event('click', {
        event_category: 'Pagination',
        event_label: `Page ${act === 'prev' ? 'Previous' : 'Next'} - Page ${this.currentPage}`,
        value: 1,
      });
      this.getStories();
    },
    async getStories() {
      try {
        const resp = await this.$http.get(
          `/v1/alumni-stories?page=${this.currentPage}&per_page=12`
        );
        this.stories = resp.data.data.storiess;
        if (resp.data.data.total)
          this.total = Math.floor(resp.data.data.total / 9) + 1;
      } catch (err) {
        console.log(err);
      }
    },
    onPageChanged(page) {
      this.$gtag.event('click', {
        event_category: 'Pagination',
        event_label: `Page Change - Page ${page}`,
        value: 1,
      });
      this.currentPage = page;
      this.getStories();
    },
    goToStoryDetail(id, title) {
      this.$gtag.event('click', {
        event_category: 'Alumni Story',
        event_label: `View Story - ${title}`,
        value: 1,
      });
      this.$router.push(`/alumni-stories/${id}`);
    },
  },
  mounted() {
    this.getStories();
  },
};
</script>

<style scoped src="./alumniStories.css"></style>
